import {OrderRequest, V2OrderIntakePayload} from '../declarations/types'

interface MapProps {
  order: OrderRequest
  country: string
  businessLine: string
  siteId: string
  orgUnitId: string
  customerId: string
}

// eslint-disable-next-line complexity
export const mapOrderRequestToV2Payload = ({
  order,
  country,
  businessLine,
  siteId,
  orgUnitId,
  customerId
}: MapProps): V2OrderIntakePayload => {
  const {payload} = order

  return {
    country,
    businessLine,
    siteId,
    orgUnitId,
    customerId,
    contactInformation: {
      orderPlacerName: payload.contact.fullName ?? '',
      orderPlacerNumber: payload.contact.mainPhone ?? '',
      carbonCopyEmail: payload.contact.carbonCopyEmail ?? '',
      siteContactName: payload.contact.siteContactName ?? '',
      siteContactNumber:
        payload.contact.backupPhone ??
        payload.contact.mainPhone ??
        payload.contact.dispatchPhone ??
        ''
    },
    customerReference: payload.customerReference,
    shippingType: payload.shippingType,
    haulerInfo: {
      trailerLicensePlate: payload.haulerInfo?.trailerLicensePlate ?? '',
      driverName: payload.haulerInfo?.driverName ?? '',
      driverPhoneNumber: payload.haulerInfo?.driverPhoneNumber ?? '',
      truckLicensePlate: payload.haulerInfo?.truckLicensePlate ?? ''
    },
    allocatorInstructions: payload.orderAllocatorInstructions ?? '',
    instructions: payload.additionalDriverInfo?.driverInstructions ?? '',
    orderCreateNotes: '',
    contractItem: payload.contractItemPositionNumber,
    contractNumber: payload.contractNumber,
    materialNumber: payload.materialNumber,
    capacity: {
      quantityType: payload.capacity.quantityType,
      quantity: payload.capacity.quantity
    },
    scheduleStartDate: `${payload.deliveryDate}T${payload.deliveryTime.earliest}`,
    scheduleEndDate: `${payload.deliveryDate}T${payload.deliveryTime.latest}`,
    slot: {
      loadingStation: payload.slot?.loadingStation ?? '',
      siloNumber: payload.slot?.siloNumber ?? '',
      externalReference: payload.slot?.externalReference ?? ''
    }
  }
}
